import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import useSegment from '../../../integrations/segment/app/hooks/use-segment'
import {getPDPath} from '../../../utils/custom-utils'

/**
 * Vertical Image Stack component
 */
export const VerticalImageStack = ({
    custom,
    tileUrl,
    imageLazyload,
    imageAltTag,
    bottomImageAltTag,
    bottomImageBgColor,
    target
}) => {
    const {site, locale} = useMultiSite()
    const segment = useSegment()

    const isLazy = imageLazyload === 'Yes' ? 'lazy' : 'eager'
    const targetValue = target === 'New-Window' ? '_blank' : '_self'
    const formattedTileUrl = getPDPath(tileUrl, site, locale)

    const ImageContent = () => {
        return (
            <Box position="relative" width="100%" overflow="hidden">
                <Box className="vertical-stack">
                    {custom?.topImage?.disBaseLink && (
                        <img
                            src={custom?.topImage?.disBaseLink}
                            alt={imageAltTag}
                            loading={isLazy}
                            width="100%"
                        />
                    )}
                    {custom?.bottomImage?.disBaseLink && (
                        <Box
                            backgroundColor={bottomImageBgColor?.value || 'black'}
                            p={'40px 56px 40px 40px'}
                            h={'148px'}
                            display={'flex'}
                            alignItems={'center'}
                        >
                            <img
                                src={custom?.bottomImage?.disBaseLink}
                                alt={bottomImageAltTag || imageAltTag}
                                loading={isLazy}
                                style={{
                                    width: 'auto',
                                    margin: '0 auto'
                                }}
                            />
                        </Box>
                    )}
                </Box>
            </Box>
        )
    }

    return (
        <Box className="image-with-text">
            <Box
                position="relative"
                m={0}
                w="100%"
                onClick={(e) => {
                    // segment
                    segment.sendPanelSelectedEvent(e, {})
                }}
            >
                {tileUrl ? (
                    <Link to={formattedTileUrl} target={targetValue} display="block">
                        <ImageContent />
                    </Link>
                ) : (
                    <ImageContent />
                )}
            </Box>
        </Box>
    )
}

VerticalImageStack.propTypes = {
    custom: PropTypes.object,
    tileUrl: PropTypes.string,
    imageLazyload: PropTypes.string,
    imageAltTag: PropTypes.string,
    bottomImageAltTag: PropTypes.string,
    bottomImageBgColor: PropTypes.shape({
        value: PropTypes.string
    }),
    target: PropTypes.string
}

export default VerticalImageStack
